<div class="d-none d-lg-block">
  <div class="banner justify-content-center" role="banner">
    <h1 class="text-white">{{ 'wallet.page.title' | translate }}</h1>
  </div>
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="bg-primary d-lg-none d-block">
  <fgb-barcode [showWallet]="false" [showBarcode]="true"></fgb-barcode>
</div>

<!-- V2 Wallet -->
<ng-container *ngIf="walletItems?.length > 0; else noWalletItems">
  <div class="wallet-redeem-carousel pt-4">
    <div class="container">
      <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
      <div class="border p-3 rounded-4 bg-white mt-3">
        <div class="row">
          <div class="col-lg-9">
            <div class="claimed-box">{{ 'rewards.wallet.history' | translate }}</div>
            <div class="font-size-14">{{ 'rewards.wallet.history.description' | translate }}</div>
          </div>
          <div class="col-lg-3 mt-4 mt-lg-2">
            <a
              class="btn w-100 text-black bg-white border-add-card d-flex flex-row align-items-center justify-content-center fw-bold"
              [routerLink]="['/rewards/claimed']"
            >
              {{ 'rewards.wallet.view.claimed' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noWalletItems>
  <div class="container">
    <h5 class="no-wallet-items mt-2 mb-3 fw-bold">{{ 'rewards.wallet.no.items' | translate }}</h5>
    <div class="border bg-white rounded-4">
      <div class="no-wallet-items-description fw-bold font-size-12 text-center text-black py-3">
        {{ 'rewards.wallet.no.items.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
